export const bulkCreateProgramSiteCoreKeys = {
  // steppersiteCore keys
  progressBar: "ProgramsAndParticipant.BulkCreateProgram.ProgressBarComponent",
  letsStart: "BulkCreateProgram.ProgressBarComponent.LetsStart",
  pleaseWait: "BulkCreateProgram.ProgressBarComponent.PleaseWait",
  bulkCreateProgramInitialMessage:
    "BulkCreateProgram.ProgressBarComponent.BulkCreateProgramInitialMessage",
  proceedToProcessYourFile:
    "BulkCreateProgram.ProgressBarComponent.ProceedToProcessYourFile",
  processed: "BulkCreateProgram.ProgressBarComponent.ProcessedProgressState",
  processingProgressState:
    "BulkCreateProgram.ProgressBarComponent.ProcessingProgressState",
  processingYourFileMessage:
    "BulkCreateProgram.ProgressBarComponent.ProcessingYourFileMessage",
  weAreProcessingYourFileMessage:
    "BulkCreateProgram.ProgressBarComponent.WeAreProcessingYourFileMessage",
  process: "BulkCreateProgram.ProgressBarComponent.ProcessProgressState",
  successProgressState:
    "BulkCreateProgram.ProgressBarComponent.SuccessProgressState",
  unProcessedProgramsMessage:
    "BulkCreateProgram.ProgressBarComponent.UnProcessedProgramsMessage",
  uploadProgressState:
    "BulkCreateProgram.ProgressBarComponent.UploadProgressState",
  youareAlmostDone: "BulkCreateProgram.ProgressBarComponent.YouareAlmostDone",
  youareDone: "BulkCreateProgram.ProgressBarComponent.YouareDone",
  youareDoneHoldOn: "BulkCreateProgram.ProgressBarComponent.YouareDoneHoldOn",
  processIcon: "BulkCreateProgram.ProgressBarComponent.ProcessIcon",
  inQueueIcon: "BulkCreateProgram.ProgressBarComponent.InQueueIcon",
  fileInQueueWaitMessage:
    "BulkCreateProgram.ProgressBarComponent.FileInQueueWaitMessage",
  inQueueProgressState:
    "BulkCreateProgram.ProgressBarComponent.InQueueProgressState",
  //landing Page

  bulkCreateProgram: "ProgramsAndParticipant.BulkCreateProgram.HeaderComponent",
  downloadSmartTemplateButton:
    "BulkCreateProgram.HeaderComponent.DownloadSmartTemplateButton",
  bulkProcessDetails:
    "ProgramsAndParticipant.BulkCreateProgram.BulkProcessDetails",
  bulkProcessName: "BulkCreateProgram.BulkProcessDetails.BulkProcessName",
  bulkProcessNamePlaceholderText:
    "BulkCreateProgram.BulkProcessDetails.BulkProcessNamePlaceholderText",
  uploadTemplate: "ProgramsAndParticipant.BulkCreateProgram.UploadTemplate",
  cancelBulkCreateProgramConfirmationMessage:
    "BulkCreateProgram.UploadTemplate.CancelBulkCreateProgramConfirmationMessage",
  deleteSmartTemplateConfirmationMessage:
    "BulkCreateProgram.UploadTemplate.DeleteSmartTemplateConfirmationMessage",
  maximumFileSizeandType:
    "BulkCreateProgram.UploadTemplate.MaximumFileSizeandType",
  replaceExistingSmartTemplateConfirmationMessage:
    "BulkCreateProgram.UploadTemplate.ReplaceExistingSmartTemplateConfirmationMessage",
  fileExceedsTheSizeLimitMessage:
    "BulkCreateProgram.UploadTemplate.FileExceedsTheSizeLimitMessage",
  invalidFileFormatMessage:
    "BulkCreateProgram.UploadTemplate.InvalidFileFormatMessage",
  uploadSmartTemplateToProceedMessage:
    "BulkCreateProgram.UploadTemplate.UploadSmartTemplateToProceedMessage",
  browseImage: "BulkCreateProgram.UploadTemplate.BrowseImage",
  excelImage: "BulkCreateProgram.UploadTemplate.ExcelImage",

  // summary page
  summaryComponent: "ProgramsAndParticipant.BulkCreateProgram.SummaryComponent",
  summaryMessage: "BulkCreateProgram.SummaryComponent.SummaryMessage",
  iAmDoneButton: "BulkCreateProgram.SummaryComponent.IAmDoneButton",
  createNewBulkProgramLink:
    "BulkCreateProgram.SummaryComponent.CreateNewBulkProgramLink",
  refreshStatusLink: "BulkCreateProgram.SummaryComponent.RefreshStatusLink",
  downloadReportCTAButton:
    "BulkCreateProgram.SummaryComponent.DownloadReportCTAButton",
  processedProgramsOption:
    "BulkCreateProgram.SummaryComponent.ProcessedProgramsOption",
  unprocessedProgramsOption:
    "BulkCreateProgram.SummaryComponent.UnprocessedProgramsOption",
  bulkCreateProgramInstructionalMessage:
    "BulkCreateProgram.SummaryComponent.BulkCreateProgramInstructionalMessage",
  processedRecords: "BulkCreateProgram.SummaryComponent.ProcessedRecords",
  totalNumberOfRecords:
    "BulkCreateProgram.SummaryComponent.TotalNumberOfRecords",
  totalNumberOfProgramsIcon:
    "BulkCreateProgram.SummaryComponent.TotalNumberofProgramsIcon",
  recordsProcessed: "BulkCreateProgram.SummaryComponent.RecordsProcessed",
  recordsUnprocessed: "BulkCreateProgram.SummaryComponent.RecordsUnprocessed",
  fileInQueueProcessingWaitMessage:
    "BulkCreateProgram.SummaryComponent.FileInQueueProcessingWaitMessage",
  cancelBulkProcessCTAButton:
    "BulkCreateProgram.SummaryComponent.CancelBulkProcessCTAButton",
  downloadUploadedFileCTAButton:
    "BulkCreateProgram.SummaryComponent.DownloadUploadedFileCTAButton",
  cancelBulkProcessConfirmationMessage:
    "BulkCreateProgram.SummaryComponent.CancelBulkProcessConfirmationMessage",
  bulkEditProgramCTAButton:
    "BulkCreateProgram.SummaryComponent.BulkEditProgramCTAButton",
};

export const programDownloadTemplateKeys = {
  //download smart template keys
  downloadSmartTemplatePopupKey:
    "ProgramsAndParticipant.BulkCreateProgram.DownloadSmartTemplatePopup",
  selectClient: "BulkCreateProgram.DownloadSmartTemplatePopup.SelectClient",
  billingDetailsConfigurationAlertMessage:
    "BulkCreateProgram.DownloadSmartTemplatePopup.BillingDetailsConfigurationAlertMessage",
};
